import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiMethod } from '../../apimethods/api-method';
import * as ngswal from "sweetalert";
import { BusinessRulesModel } from './business-ruleModel';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';


declare var $;

@Component({
    selector: 'app-business-rules',
    templateUrl: './business-rules.component.html',
    styleUrls: ['./business-rules.component.css']
})
/** business-rules component*/
export class BusinessRulesComponent implements OnInit {

  modelItem = new BusinessRulesModel();
  dataTable: any; @ViewChild('dataTable', { static: false }) table; dataSet: any;
  popupButtonText: string;
  title: string;
    RuleTypeList: any;


  ngOnInit() {
    ApiMethod.getBaseUrl();
    $('#RuleMailSubject').jqte();
    $('#popupbody').css('height', (GlobalConstants.size.height - 15));
    $('#MailSubject .jqte_editor').css({ 'height': (GlobalConstants.size.height - 200), 'resize': 'none' });
 
  }


  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(

      data => {
        this.modelItem = <BusinessRulesModel>data["BusinessRulePage"];
        this.GetBusinessRules();

        $('#ddlRuleType').select2({
          placeholder: "Select ",
          /*allowClear: true, tags: true,*/
          dropdownParent: "#btnPopupartDetails"
        });
        $('#ddlRuleType').val([]).trigger('change');

        this.GetRuleTypeList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  ngAfterViewChecked(): void {
    if ($('.jqte').length == 0) {
      $('#RuleMailSubject').jqte();
    }
  }

  GetRuleTypeList(): void {
    ApiMethod.getMethod(this.modelItem.RuleTypeListAPI).subscribe(
      result => {
        this.RuleTypeList = result.aRuletypeList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetBusinessRules() {
    $("#LoadingImage").show();

    var BusinessRulesData = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };

    ApiMethod.postMethod(this.modelItem.BusinessRulesAPI, BusinessRulesData).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.aitemList);
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = "btn_AddNew";
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 160);
        dataItem.modulename = "BusinessRuleModule";
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();


      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  showBusinessRules(): void {
    $("#ddlRuleType").prop('disabled', false);
    $("#btnPopupartDetails").show();
    this.ClearData();
    if (localStorage.aEID != 0) {
      $("#LoadingImagePopup").show();
      ApiMethod.getMethod(this.modelItem.BusinessRulesListByID + '/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          let aitems = result.aitemList;
          console.log(aitems);

          $("#ddlRuleType").prop('disabled', true).val(aitems[0].RuleTypeId).change();
          /*$('#Txt_RuleID').val(aitems[0].RuleId);*/
          $('#Txt_RuleID').val(aitems[0].RuleId).prop('disabled', true);
          $('#Txt_RuleName').val(aitems[0].RuleName);
          $('#RuleDescription').val(aitems[0].RuleDescription);
          $('#ActionofFailure').val(aitems[0].ActionOfFailure);
          $('#RuleHeadContent').val(aitems[0].HeadContent);
          $('#BottomContent').val(aitems[0].BottomContent);
          $('#MailSubject .jqte_editor').html(aitems[0].MailSubject);
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
        }
      );
      this.popupButtonText = "Update";
    } else this.popupButtonText = "Save";
    this.title = "Business Rules Details";
  }

  UpdateBusinessRules(): void {
    if ($('#ddlRuleType').val() == '') {
      ngswal("Warning !", "Enter RuleType!", "warning");
    }
    else if ($('#Txt_RuleName').val() == '') {
      ngswal("Warning !", "Enter Rule Name!", "warning");
    }
    else if ($('#RuleDescription').val() == '') {
      ngswal("Warning !", "Enter Description!", "warning");
    }

    else {
      $("#LoadingImagePopup").show();
      var businessRulesListData =
      {
        Id: localStorage.aEID,
        RuleTypeId: $('#ddlRuleType').val(),
        RuleId: $('#Txt_RuleID').val(),
        RuleName: $('#Txt_RuleName').val(),
        RuleDescription: $('#RuleDescription').val(),
        ActionOfFailure: $('#ActionofFailure').val(),
        HeadContent: $('#RuleHeadContent').val(),
        MailSubject: $('#RuleMailSubject').val(),
        BottomContent: $('#BottomContent').val(),
        CreatedBy: localStorage.aLoginID,
        UpdatedBy: localStorage.aLoginID

      };
      console.log(businessRulesListData);

      ApiMethod.postMethod(this.modelItem.businessRulesListDataAPI, businessRulesListData).subscribe(
        response => {
          this.GetBusinessRules();
          $("#LoadingImagePopup").hide();
          if (response.status) {
            ngswal("Success !", response.message, "success");
          } else {
            ngswal("Success !", response.message, "Failed");
          }
          
          this.hide();
        },
        error => {
          ngswal("Failed!", error.error.Message, "error");
          $("#LoadingImagePopup").hide();
        }
      );

    }

  }

  deleteBusinessRule() {
    //$("#LoadingImagePopup").show();
    //ApiMethod.getMethod(this.modelItem.DeleteBusinessRuleTypeID + "/" + localStorage.aEID).subscribe(
    //  Response => {
    //    this.hide();
    //    this.GetBusinessRuleType();
    //    if (Response.status) {
    //      ngswal({
    //        position: 'top-end',
    //        type: "success",
    //        title: "Updated !",
    //        text: Response.message,
    //        showConfirmButton: true,
    //      });
    //    } else {
    //      ngswal({
    //        position: 'top-end',
    //        type: "warning",
    //        title: "Failed !",
    //        text: Response.message,
    //        showConfirmButton: true,
    //      });
    //    }

    //    $("#LoadingImagePopup").hide();
    //  }, error => {
    //    $("#LoadingImagePopup").hide();
    //    ngswal("Failed !", error.message, "error");
    //  }
    //);
  }

  Deleteconfirmation() {
    ngswal({
      title: "Are You Confirm to delete Business Rule Type?",
      text: "Business Rule Type deleted Permanently..!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#btnDeleteBusinessRule').trigger("click");
        } else {
          return false;
        }
      });
  };
   
  GetRuleTypeId() {
    var RuletypeListId = $('#ddlRuleType').val();
    if (localStorage.aEID == 0) {
      ApiMethod.getMethod(this.modelItem.businessRuleTypeListDataAPI + '/' + RuletypeListId).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          let resultString = "";
          let aitems = result.aitemList;
          let inputString = aitems[0].RuleId;
          let numericPart = inputString.match(/\d+/);

          if (numericPart) {
            // Convert the numeric part to a number, add 1, and format it back to a string with leading zeros
            let incrementedValue = String(Number(numericPart[0]) + 1).padStart(numericPart[0].length, '0');

            // Replace the numeric part in the original string with the incremented value
            resultString = inputString.replace(/\d+/, incrementedValue);
            $('#Txt_RuleID').val(resultString).prop('disabled', true);
            console.log(resultString);
          } else {
            console.log("No numeric part found in the input string");
          }
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
        }
      );
  }
  } 


  ClearData(): void {
    $("#RuleDescription").val("");
    $("#ActionofFailure").val("");
    $("#RuleHeadContent").val("");
    $("#BottomContent").val("");
    $('#MailSubject .jqte_editor').html('');
    $("#Txt_RuleID").val("");
    $("#Txt_RuleName").val("");
    $("#ddlRuleType").val(0).change();
  }

  hide(): void {
    $("#btnPopupartDetails").hide();

  }
 
}


